import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TipsSection() {
  const [activeDot, setActiveDot] = useState(0);
  const handlePrev = () => setActiveDot(prev => prev === 0 ? 1 : 0);
  const handleNext = () => setActiveDot(prev => prev === 1 ? 0 : 1);
  return <section className="w-full bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-513">
      <div className="max-w-6xl mx-auto" data-id="element-514">
        {/* Heading */}
        <div className="text-center mb-12" data-id="element-515">
          <h2 className="font-black text-3xl sm:text-4xl text-black uppercase tracking-wide" data-id="element-516">
            Tire Tips &amp; Advice
          </h2>
          <div className="w-16 h-1 mx-auto mt-3" style={{
          background: '#1A3BCC'
        }} data-id="element-517" />
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-518">
          {/* Card 1 */}
          <div className="border border-gray-200 rounded overflow-hidden flex flex-col" data-id="element-519">
            <img src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=600&q=80" alt="Mechanic working on tire" className="h-52 w-full object-cover" data-id="element-520" />
            <div className="p-5 flex flex-col flex-1" data-id="element-521">
              <h3 className="font-black text-black text-base mb-3 uppercase leading-snug" data-id="element-522">
                How to Know When to Replace Your Tires
              </h3>
              <div className="flex-1" data-id="element-523" />
              <Link to="/services/tire-sales" className="font-semibold text-sm transition-colors" style={{
              color: '#CC0000'
            }} onMouseEnter={e => e.currentTarget.style.color = '#AA0000'} onMouseLeave={e => e.currentTarget.style.color = '#CC0000'} data-id="element-524">
                Learn more
              </Link>
            </div>
          </div>

          {/* Card 2 */}
          <div className="border border-gray-200 rounded overflow-hidden flex flex-col" data-id="element-525">
            <img src="https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=600&q=80" alt="Tire shop service" className="h-52 w-full object-cover" data-id="element-526" />
            <div className="p-5 flex flex-col flex-1" data-id="element-527">
              <h3 className="font-black text-black text-base mb-3 uppercase leading-snug" data-id="element-528">
                How Often Should You Rotate Your Tires?
              </h3>
              <div className="flex-1" data-id="element-529" />
              <Link to="/services/tire-rotation" className="font-semibold text-sm transition-colors" style={{
              color: '#CC0000'
            }} onMouseEnter={e => e.currentTarget.style.color = '#AA0000'} onMouseLeave={e => e.currentTarget.style.color = '#CC0000'} data-id="element-530">
                Learn more
              </Link>
            </div>
          </div>

          {/* Card 3 */}
          <div className="border border-gray-200 rounded overflow-hidden flex flex-col" data-id="element-531">
            <img src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=600&q=80" alt="Car maintenance" className="h-52 w-full object-cover" data-id="element-532" />
            <div className="p-5 flex flex-col flex-1" data-id="element-533">
              <h3 className="font-black text-black text-base mb-3 uppercase leading-snug" data-id="element-534">
                What Is Tire Pressure and Why Does It Matter?
              </h3>
              <div className="flex-1" data-id="element-535" />
              <Link to="/services/free-tire-checks" className="font-semibold text-sm transition-colors" style={{
              color: '#CC0000'
            }} onMouseEnter={e => e.currentTarget.style.color = '#AA0000'} onMouseLeave={e => e.currentTarget.style.color = '#CC0000'} data-id="element-536">
                Learn more
              </Link>
            </div>
          </div>
        </div>

        {/* Carousel dots */}
        <div className="mt-8 flex items-center justify-center gap-3" data-id="element-537">
          <button onClick={handlePrev} className="text-gray-400 hover:text-[#822433] transition-colors p-1" aria-label="Previous" data-id="element-538">
            <ChevronLeftIcon size={22} data-id="element-539" />
          </button>
          <button onClick={() => setActiveDot(0)} className="w-3 h-3 rounded-full transition-colors" style={{
          background: activeDot === 0 ? '#CC0000' : '#d1d5db'
        }} aria-label="Page 1" data-id="element-540" />
          <button onClick={() => setActiveDot(1)} className="w-3 h-3 rounded-full transition-colors" style={{
          background: activeDot === 1 ? '#CC0000' : '#d1d5db'
        }} aria-label="Page 2" data-id="element-541" />
          <button onClick={handleNext} className="text-gray-400 hover:text-[#822433] transition-colors p-1" aria-label="Next" data-id="element-542">
            <ChevronRightIcon size={22} data-id="element-543" />
          </button>
        </div>
      </div>
    </section>;
}